// The selection strip above the pipeline: select every lead on screen, see how many
// are ticked, and delete them.
//
// "Every lead on screen" is deliberate — the box acts on the leads AFTER the mine /
// urgency / stage filters, which is both what the eye expects and how a partner deletes
// one stage's worth of dead prospects: filter to that stage, tick the box, delete. So
// the label carries the number it will select, and it is never a promise about leads
// that are not visible.
//
// The bar only appears once there are leads to act on, and the delete button only once
// something is ticked: an always-present red button on a screen whose main job is
// pipeline work is an invitation to a mis-click.
import he from '../../i18n/he';
import Button from '../../components/Button';

export default function SelectionBar({ total, selectedCount, onToggleAll, onClear, onDelete }) {
  const allSelected = total > 0 && selectedCount === total;

  return (
    <div className="lead-select-bar">
      <label className="lead-select-all">
        <input
          type="checkbox"
          checked={allSelected}
          // Ticked-but-not-all reads as a third state, not as "none selected".
          ref={(el) => { if (el) el.indeterminate = selectedCount > 0 && !allSelected; }}
          onChange={onToggleAll}
        />
        <span>{he.leads.selectAll(total)}</span>
      </label>

      {selectedCount > 0 && (
        <div className="lead-select-actions">
          <span className="muted">{he.leads.selectedCount(selectedCount)}</span>
          <Button small variant="subtle" onClick={onClear}>{he.leads.clearSelection}</Button>
          {/* Red inline rather than a `danger` variant, matching the delete dialogs:
              ui.css defines one for icon-btn only. */}
          <Button
            small
            onClick={onDelete}
            variant="danger"
          >
            {he.leads.deleteSelected}
          </Button>
        </div>
      )}
    </div>
  );
}
